import { Controller } from "@hotwired/stimulus"

const CHECKED_COOKIE = /(?:^|; )bt_human_check=/
const MAX_SUBMISSIONS = 3
let submissions = 0
let submitting = false
let turnstileLoaded

const loadTurnstile = () =>
  (turnstileLoaded ||= new Promise((resolve, reject) => {
    window.onTurnstileLoad = resolve
    const script = document.createElement("script")
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=onTurnstileLoad"
    script.onerror = () => {
      script.remove()
      turnstileLoaded = null
      reject()
    }
    document.head.appendChild(script)
  }))

export default class extends Controller {
  static values = { siteKey: String, uid: String }

  connect() {
    if (submitting || submissions === MAX_SUBMISSIONS || CHECKED_COOKIE.test(document.cookie)) return

    loadTurnstile().then(
      () => this.render(),
      () => {},
    )
  }

  render() {
    if (!this.element.isConnected) return

    this.widgetId = window.turnstile.render(this.element, {
      sitekey: this.siteKeyValue,
      "refresh-expired": "never",
      callback: (token) => this.submit(token),
    })
  }

  disconnect() {
    this.removeWidget()
  }

  submit(token) {
    const release = () => (submitting = false)
    submitting = true
    submissions += 1
    const body = new URLSearchParams({ token, uid: this.uidValue })
    fetch("/api/human_checks", { method: "POST", body, keepalive: true }).then(release, release)
    this.removeWidget()
  }

  removeWidget() {
    if (this.widgetId === undefined) return

    window.turnstile.remove(this.widgetId)
    this.widgetId = undefined
  }
}
